import { Button, darken, useTheme } from '@mui/material'

import { pathToMarketingSiteBuilder } from '~/features/marketing/utils'
import { EChatbotTheme } from '~/features/settings/models'
import { EMarketingClientPath } from '~/models/api'
import { store } from '~/store'
import pathBuilder from '~/utils/api'
import rem from '~/utils/ui'

function CreateYourFreeLibbyButton() {
  const theme = useTheme()

  const [chatbotLayout, referralCode] = store((state) => [
    state.chatbot.layout,
    state.organization.referralCode,
  ])
  const pathToMarketingSite = referralCode
    ? pathBuilder(EMarketingClientPath.referralLink, { referralCode })
    : EMarketingClientPath.home

  const linkToMarketingSite = pathToMarketingSiteBuilder(pathToMarketingSite)

  return (
    <Button
      onClick={() => window.open(linkToMarketingSite, '_blank')}
      variant="primary"
      sx={{
        backgroundColor:
          chatbotLayout.selection.theme === EChatbotTheme.simple
            ? theme.palette.tertiary3
            : theme.palette.common.white,
        color: theme.palette.mainFont,
        height: 'auto',
        fontSize: rem(16),
        minWidth: 'initial',
        maxWidth: 'fit-content',
        lineHeight: 'initial',
        whiteSpace: 'break-spaces',
        '&.MuiButton-primaryPrimary': {
          paddingInline: rem(15),
        },
        '&:hover': {
          backgroundColor: darken(theme.palette.tertiary3, 0.1),
        },
      }}
    >
      Create your own Libby
    </Button>
  )
}
export default CreateYourFreeLibbyButton
